module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("cWZQT"))).then(() => parcelRequire('dptSB'));